import { createReducer, on } from "@ngrx/store";
import { TenderActions } from "./tender.actions";
import { initialTenderState } from "./tender.state";

export const tenderReducer = createReducer(
    initialTenderState,

    // 1. Setting the active Tender (from a list or sidebar)
    on(TenderActions.setCurrentTender, (state, { tender }) => ({
        ...state,
        currentTender: tender,
        errorMessage: null
    })),

    // 2. Loading Execution: Start
    on(TenderActions.loadExecutionTenderByProjectId, (state) => ({
        ...state,
        loading: true,
        execution: null, 
        errorMessage: null 
    })),

    // 3. Loading Execution: Success
    on(TenderActions.loadExecutionTenderByProjectIdSuccess, (state, { tender }) => ({
        ...state,
        execution: tender,
        loading: false,
        errorMessage: null
    })),

    // 4. Loading Execution: Fail
    on(TenderActions.loadExecutionTenderByProjectIdFail, (state, { error }) => ({
        ...state,
        execution: null,
        loading: false,
        errorMessage: error
    })),

    // 5. Handling APU resource selection
    on(TenderActions.selectedMaterialResource, (state, { apuResource }) => ({
        ...state,
        selectedApuResourceMaterial: apuResource
    })),
);